import { useEffect, useState } from 'react';

import { Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { BusyEntry, OperationContractType } from 'models/OperationRequest';

const MIN_REASON = 8;

interface ForceTypeModalProps {
  open: boolean;
  personLabel: string;
  conflict: BusyEntry | null;
  requestType: OperationContractType;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
}

function ForceTypeModal({
  open,
  personLabel,
  conflict,
  requestType,
  onCancel,
  onConfirm,
}: ForceTypeModalProps) {
  const { t } = useTranslation();
  const i18nBase =
    'scenes.requirements_operation.components.assign_people.board.force';
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (open) setReason('');
  }, [open]);

  const ok = reason.trim().length >= MIN_REASON;
  const typeLabel = (type: OperationContractType) =>
    t(`scenes.requirements_operation.scene.contract.${type}`);

  return (
    <Modal
      open={open}
      title={t(`${i18nBase}.title`)}
      okText={t(`${i18nBase}.confirm`)}
      cancelText={t(`${i18nBase}.cancel`)}
      okButtonProps={{ disabled: !ok, danger: true }}
      onCancel={onCancel}
      onOk={() => ok && onConfirm(reason.trim())}
      destroyOnClose
    >
      {conflict && (
        <p>
          {t(`${i18nBase}.description`, {
            name: personLabel,
            otherType: typeLabel(conflict.type),
            brand: conflict.brand,
            campaign: conflict.campaign,
            type: typeLabel(requestType),
          })}
        </p>
      )}
      <Input.TextArea
        rows={3}
        value={reason}
        maxLength={500}
        placeholder={t(`${i18nBase}.placeholder`)}
        onChange={(e) => setReason(e.target.value)}
      />
      <div style={{ marginTop: 6, fontSize: 12, color: 'rgba(0,0,0,0.45)' }}>
        {t(`${i18nBase}.hint`, { count: MIN_REASON })}
      </div>
    </Modal>
  );
}

export default ForceTypeModal;
